import { IFormViewForm } from 'components/FormView';

const UpdateDueDatesDialog: IFormViewForm = {
    id: 'UpdateDueDatesForm',
    layout: {
        rows: 1,
        columns: 1,
    },
    fields: [
        {
            id: 1,
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                name: 'activity',
                fullWidth: true,
                elevation: 0,
                minColumnWidth: 300
            },
            position: {
                row: 1,
                col: 1,
            },
            children: [
                {
                    id: '1',
                    type: 'SELECT_FIELD',
                    visible: true,
                    style: {
                        width: '100%'
                    },
                    props: {
                        label: 'Due date update option',
                        name: 'DueDateOption',
                        placeholder: '',
                        size: 'large',
                        apiPrefs: {
                            path: '/CustomTypes/Lookup/PurchaseOrderDueDateOption/Search',
                            method: 'POST',
                            params: null
                        },
                    }
                },
                {
                    id: 2,
                    type: 'DATE_FIELD',
                    props: {
                        label: 'Due date to be replaced',
                        name: 'SpecificDueDate',
                        dateFormat: 'DD/MM/YYYY',
                        placeholder: '',
                        size: 'small',
                        defaultValue: '',
                        nullable: true
                    }
                },
                {
                    id: 3,
                    type: 'DATE_FIELD',
                    props: {
                        label: 'New due date',
                        name: 'NewDueDate',
                        dateFormat: 'DD/MM/YYYY',
                        placeholder: 'DD/MM/YYYY',
                        size: 'small',
                        required: true
                    }
                },
            ]

        }
    ]
};

export default UpdateDueDatesDialog;
